import React from "react";
import './NotFound.css';
import lostImage from '../../resources/assets/lost.png'

function NotFound() {
  return (
    <div className="lost">
      <div style={{backgroundImage: `url(${lostImage})`}} alt="404: Page not found." className="background-image solid" loading="lazy" height="100" width="100" />
      <div className="lost-text">
        <h1>404: Not Found</h1>
        <p>You're just as lost as these two.</p>
      </div>
    </div>
  );
}

export default NotFound;